import { render, staticRenderFns } from "./TiCronDB2.vue?vue&type=template&id=2ee224e2"
import script from "./TiCronDB2.vue?vue&type=script&lang=js"
export * from "./TiCronDB2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports